import { render, staticRenderFns } from "./DiagramLink.vue?vue&type=template&id=71e2b2ed&"
import script from "./DiagramLink.vue?vue&type=script&lang=js&"
export * from "./DiagramLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/max/WORK/vue-diagram-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e2b2ed')) {
      api.createRecord('71e2b2ed', component.options)
    } else {
      api.reload('71e2b2ed', component.options)
    }
    module.hot.accept("./DiagramLink.vue?vue&type=template&id=71e2b2ed&", function () {
      api.rerender('71e2b2ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiagramLink.vue"
export default component.exports